'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.FooterSlide = void 0;
const swiper_1 = require("swiper");
const modules_1 = require("swiper/modules");
class FooterSlide {
    constructor() {
        const footerSwiper = new swiper_1.default(".bulletFooterSlider", {
            modules: [modules_1.Navigation, modules_1.Autoplay],
            loop: true,
            slidesPerView: 1.5,
            spaceBetween: 15,
            // centeredSlides: true,
            // slidesPerGroup: 3,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                // スライドの表示枚数：768px以上の場合
                768: {
                    slidesPerView: 3,
                },
            }
        });
    }
}
exports.FooterSlide = FooterSlide;
exports.default = FooterSlide;
